import {
    HttpContextToken,
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
    clearStoredAuthSession,
    getStoredAuthToken,
} from './auth.service';

export const AUTH_SKIP_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
export const AUTH_SUPPRESS_401_REDIRECT = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const router = inject(Router);

    const shouldSkip = request.context.get(AUTH_SKIP_INTERCEPTOR);
    const token = getStoredAuthToken();

    const requestToHandle = shouldSkip || !token
        ? request
        : request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                },
            });

    return next(requestToHandle).pipe(
        catchError((error: unknown) => {
            if (!(error instanceof HttpErrorResponse)) {
                return throwError(() => error);
            }

            if (error.status === 401) {
                clearStoredAuthSession();

                if (!request.context.get(AUTH_SUPPRESS_401_REDIRECT)) {
                    void router.navigate(['/login']);
                }
            }

            if (error.status === 426) {
                clearStoredAuthSession();
                window.alert('update required / obsolete version');
            }

            return throwError(() => error);
        }),
    );
};
